import React from 'react';
import PropTypes from 'prop-types';
import Constants from '../../containers/function/constants.js';

/* IMG */
import Logo from '../../../../public/images/logo-gauss.png';

const HeaderComponent = props => (
  <header>
    <div className="logo">
      <img async="on" src={`${Logo}`} alt="Gauss control" />
    </div>
    <div className="container_header">
      <div className="container_header__filter" />
      <div className="container_header__button">
        <div className="header_icon">
        {(props.helpRepeatTourAction!=null) && (
          <div>
            <i id="help" onClick={props.handleNotification} className="fas fa-question-circle" />
            <div className={props.help ? `box_header active` : `box_header`}>
              <h6>{props.language.filter ? props.language.filter.help : ''}</h6>
              <ul>
                <li>
                  <a id="help-repeat-tour" onClick={(e) => {
                      props.handleNotification(e);
                      props.helpRepeatTourAction();
                    }}>
                    <div>
                      <i className="fas fa-question-circle" />
                    </div>
                    <div>{props.language.filter ? props.language.filter.repeatTour : ''}</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}
        </div>
        <div className="task_indicators_wrapper">
        {(false && props.taskManagerIndicatorsData!=null && 
          props.permits && props.permits.includes('task')) && 
          props.taskManagerIndicatorsData.map((item,i) => {
          return (        
            <div 
              className={"header_icon task_indicators task_indicators_" + item.indicatorType.toLowerCase()}
              onClick={props.handleTaskIndicatorsClick}
              key={i}
              data-type={item.indicatorType}
            >
              <div className="taskmanager_icons"/>
              <div className="task_indicators_quantity">{item.quantity}</div>
              <div className="task_indicators_help">
                <p>{props.language.nav.taskManagerIndicators[item.indicatorType.toLowerCase()]}</p>
              </div>
            </div>
          );
        })}
        </div>
        <div className="header_icon">
          <i id="user" onClick={props.handleNotification} className="fas fa-user" />
          <div className={props.user ? `box_header active` : `box_header`}>
            <h6>{props.language.filter ? props.language.filter.user : ''}</h6>
            <ul>
              <li>
                <a className="no-link">
                  <div>
                    <i className="fas fa-user" />
                  </div>
                  <div>{props.email}</div>
                </a>
              </li>
              {props.permits
                && props.permits.includes('profile') && (
                <li>
                  <a id="user-profile" onClick={(e) => {
                      props.handleUserProfile(e);
                      props.handleNotification(e);
                    }}>
                    <div>
                      <i className="fas fa-user-edit" />
                    </div>
                    <div>{props.language.filter ? props.language.filter.profile : 'Perfil'}</div>
                  </a>
                </li>
              )}
              <li>
                <a onClick={props.handleLogOut}>
                  <div>
                    <i className="fas fa-lock" />
                  </div>
                  <div>{props.language.filter ? props.language.filter.closeSession : 'Cerrar sesión'}</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
);

export default HeaderComponent;



// WEBPACK FOOTER //
// ./source/client/components/header/index.jsx